import * as formik from 'formik';
import * as fabric from 'office-ui-fabric-react';
import { FC, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import * as api from '../../../../../api/generated';
import { ILocationItem } from '../../../../../components/custom/LocationTree';
import { LocationContext } from '../../../../../components/LocationContext';
import KendoLoading from '../../../../../components/spinners/KendoLoading';
import { IWindowComponentProps } from '../../../../../components/windows/WindowContext';
import * as enums from '../../../../../enums';

interface ILocationTreeRootCreateWindowProps {
    refetchLocations(): Promise<void>;
}

const validationSchema = Yup.object<ILocationItem>().shape({
    name: Yup.string().required('Šis laukas yra privalomas')
});

const LocationTreeRootCreateWindow: FC<IWindowComponentProps<ILocationTreeRootCreateWindowProps>> = (props) => {
    const {
        componentProps: { refetchLocations },
        onClose
    } = props;

    const { organizationInformationId } = useParams<'organizationInformationId'>();
    const [isLoading, setIsLoading] = useState(false);
    const { getLocations } = useContext(LocationContext);

    const initialValues: ILocationItem = {
        id: 0,
        partOfLocationId: null,
        name: '',
        locationStatus: enums.locationStatus.Closed,
        locationType: enums.locationType.Building,
        key: null,
        doorControllerKey: null,
        activeTicketPrintingTimeBeforeVisit: null,
        activeTicketPrintingTimeAfterVisit: null,
        floor: null,
        isActiveTicketPrintingTimeAfterVisitEnabled: null,
        isActiveTicketPrintingTimeBeforeVisitEnabled: null
    };

    const handleSubmit = async (values: ILocationItem, formikActions: formik.FormikHelpers<ILocationItem>) => {
        formikActions.setStatus();

        try {
            setIsLoading(true);
            await api.administration.createLocation(values);
            toast.success('Lokacija sėkmingai sukurta');
            getLocations(parseInt(organizationInformationId.toString()));
            onClose();
        } catch (ex) {
            formikActions.setStatus(ex);
            toast.error(ex.error[0]);
        } finally {
            setIsLoading(false);
            formikActions.setSubmitting(false);
        }
    };

    return (
        <>
            {isLoading ? (
                <KendoLoading />
            ) : (
                <>
                    <formik.Formik validationSchema={validationSchema} initialValues={initialValues} onSubmit={handleSubmit}>
                        {(formikProps) => (
                            <formik.Form>
                                <div className="ms-Grid">
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-md6">
                                            <formik.Field name="name">
                                                {({ field, form }: formik.FieldProps<string>) => (
                                                    <fabric.TextField
                                                        {...field}
                                                        label="Pavadinimas"
                                                        placeholder="Įrašykite objekto pavadinimą"
                                                        errorMessage={
                                                            (formikProps.status && formikProps.status.name) || (form.errors.name && form.errors.name)
                                                        }
                                                    />
                                                )}
                                            </formik.Field>
                                        </div>
                                        <div className="ms-Grid-col ms-md6">
                                            <fabric.TextField label="Lokacijos tipas" readOnly value={enums.locationType.format(1)} disabled />
                                        </div>
                                    </div>
                                    <div style={{ textAlign: 'center', marginTop: '30px' }}>
                                        <fabric.PrimaryButton
                                            className="ms-slideRightIn40 ms-textAlignRight"
                                            text="Išsaugoti"
                                            disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
                                            type="submit"
                                        />
                                    </div>
                                </div>
                            </formik.Form>
                        )}
                    </formik.Formik>
                </>
            )}
        </>
    );
};

export default LocationTreeRootCreateWindow;
